import { Button, Dialog, Intent, Shape } from '@axieinfinity/matcha'
import { CheckIcon, WarningCircleIcon } from '@axieinfinity/matcha-icons'

type TWalletUnlinkModalProps = {
  disabled?: boolean
  visible?: boolean
  onConfirm?: () => void
  onClose?: () => void
}

const WalletUnlinkModal: React.FC<TWalletUnlinkModalProps> = ({
  visible,
  disabled,
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog
      className="[&_.dango-dialog-content]:bg-surface-color-default [&_.dango-dialog-content]:border [&_.dango-dialog-content]:border-border-color-default [&_.dango-dialog-body]:p-0 [&_.dango-dialog-content]:!p-0 p-16 !w-[390px] sm:!w-[500px]"
      visible={visible}
      onClose={onClose}
      destroyOnClose
      size="small"
    >
      <div className="flex flex-col p-24">
        <div className="mb-12 mt-8 text-h4 pr-12">
          Are you sure you want to unlink your wallet?
        </div>

        <div className="flex flex-col gap-12 mb-24">
          <div className="flex gap-8 items-center text-body-m text-text-color-subdued">
            <CheckIcon className="text-green-5" />
            <span>You can still link another wallet to this account.</span>
          </div>

          <div className="flex gap-8 text-body-m text-text-color-subdued">
            <WarningCircleIcon className="mt-4 text-yellow-10" />
            <span className="flex-1">
              {`You can't link this wallet to another account `}
              <span className="text-text-color-default">
                for the next 30 days
              </span>
              .
            </span>
          </div>
        </div>

        <div className="flex w-full items-center justify-end gap-16">
          <Button
            shape={Shape.Default}
            onClick={onClose}
            disabled={disabled}
            text="Cancel"
          />

          <Button
            shape={Shape.Default}
            intent={Intent.Danger}
            disabled={disabled}
            onClick={onConfirm}
            text="Unlink"
          />
        </div>
      </div>
    </Dialog>
  )
}

export default WalletUnlinkModal
